module.exports = __webpack_public_path__ + "img/jomalone_logo_footer.db1f328f.png";